// extracted by mini-css-extract-plugin
module.exports = {"right-card-wrapper":"index_right-card-wrapper_1_nZF"};